import React from "react";

const SidebarVelkie = ({ setSidebarModal }) => {
  return (
    <div
      className="fixed w-full h-screen top-0 overflow-hidden z-50"
      data-v-83e0514d=""
    >
      <div
        className="relative px-4 py-3 left-0 top-0 z-50 w-3/4 bg-black-100 h-full overflow-y-scroll"
        data-v-83e0514d=""
        style={{}}
      >
        <div data-v-83e0514d="">
          <div
            className="mt-1 mb-2 px-2 flex justify-between"
            data-v-83e0514d=""
          >
            <span className="font-bold text-15" data-v-83e0514d="">
              Menu
            </span>
            <i
              onClick={() => setSidebarModal(false)}
              className="icon-close"
              data-v-83e0514d=""
            />
          </div>

          <div className="item-block" data-v-83e0514d="">
            <div className="item" data-v-83e0514d="">
              <span className="icon icon-list" data-v-83e0514d="" />
              <span
                className="flex items-center justify-center"
                data-v-83e0514d=""
              >
                {" "}
                Current Bets{" "}
              </span>
              <span className="icon-right icon-arrow-left" data-v-83e0514d="" />
            </div>
            <div className="item" data-v-83e0514d="">
              <span className="icon icon-history" data-v-83e0514d="" />
              <span data-v-83e0514d="">Bets History</span>
              <span className="icon-right icon-arrow-left" data-v-83e0514d="" />
            </div>
            <div className="item" data-v-83e0514d="">
              <span className="icon icon-profit-loss" data-v-83e0514d="" />
              <span data-v-83e0514d="">Profit & Loss</span>
              <span className="icon-right icon-arrow-left" data-v-83e0514d="" />
            </div>
            {/* <div className="item" data-v-83e0514d="">
              <span className="icon icon-active-log" data-v-83e0514d="" />
              <span data-v-83e0514d="">Active Log</span>
              <span className="icon-right icon-arrow-left" data-v-83e0514d="" />
            </div> */}
            <div className="item" data-v-83e0514d="">
              <span className="icon icon-profile" data-v-83e0514d="" />
              <span data-v-83e0514d="">My Profile</span>
              <span className="icon-right icon-arrow-left" data-v-83e0514d="" />
            </div>
          </div>

          <div className="item-block" data-v-83e0514d="">
            <div className="item item-black" data-v-83e0514d="">
              <span className="icon icon-logout" data-v-83e0514d="" />
              <span data-v-83e0514d="">Logout</span>
              <span className="icon-right icon-arrow-left" data-v-83e0514d="" />
            </div>
          </div>
        </div>
        <div
          className="time-zone px-3 mt-6 flex justify-center items-start text-black-600"
          data-v-83e0514d=""
        >
          <i className="icon-sphere w-5 text-16" data-v-83e0514d="" />
          <p className="text-13 leading-tight" data-v-83e0514d="">
            Time Zone：GMT+6:00
          </p>
        </div>
      </div>
    </div>
  );
};

export default SidebarVelkie;
